import CustomDateRange from "components/Atoms/CustomDateRange"
import StaticSelector from "components/Atoms/StaticSelector"
import StringInput from "components/Atoms/StringInput"
import DynamicSelector from "components/Molecules/DynamicSelector"
import SearchFilter, {
  SearchFilterCallout,
} from "components/Organisms/SearchFilter"
import {
  MARKET_YARDS,
  REFERENCE_GRADES,
  USERS,
  VARIETY_GROUPS,
} from "graphql/selector.queries.gql"
import { useCurrentDepartment } from "hooks/useAuth"
import currencySymbol from "locale/currency"
import React from "react"
import { useFilter } from "store/search-filter/search-filter.reducer"
import { PRICING_DONE_ON, SELLER_TYPES } from "data/static.items"

const BenchmarkFilter = () => {
  const departmentId = useCurrentDepartment()
  const [filter, setFilter] = useFilter("benchmarks")

  return (
    <SearchFilter
      value={filter}
      getValues={values => setFilter(values)}
      onClear={() => setFilter({})}
      className="ml-3"
    >
      <SearchFilterCallout title="Benchmark date range">
        <CustomDateRange
          className="my-3"
          label="From - To"
          inline
          big={false}
          path="dateRange"
        />
      </SearchFilterCallout>
      <SearchFilterCallout title="Benchmark type">
        <StaticSelector
          label="Seller"
          inline
          items={SELLER_TYPES}
          className="my-3"
          big={false}
          path="benchmarkType"
        />
      </SearchFilterCallout>
      <SearchFilterCallout title="Benchmark Done By">
        <DynamicSelector
          label="User"
          inline
          query={USERS}
          searchVector={["fullName", "number"]}
          name={["fullName"]}
          variables={{ group: "Benchmarking Officer" }}
          className="my-3"
          big={false}
          path="benchmarkDoneById"
        />
      </SearchFilterCallout>
      <SearchFilterCallout title="Market Yard">
        <DynamicSelector
          label="Market yard"
          query={MARKET_YARDS}
          className="my-3"
          inline
          big={false}
          path="marketYardId"
        />
      </SearchFilterCallout>
      <SearchFilterCallout title="Variety Group">
        <DynamicSelector
          label="Group"
          query={VARIETY_GROUPS}
          variables={{ departmentId }}
          className="my-3"
          inline
          big={false}
          path="commodityGroupId"
        />
      </SearchFilterCallout>
      <SearchFilterCallout title="Grade">
        <DynamicSelector
          label="Reference Grade"
          inline
          query={REFERENCE_GRADES}
          className="my-3"
          big={false}
          path="gradeId"
        />
      </SearchFilterCallout>
      <SearchFilterCallout title="Rejection %">
        <StringInput
          label="Percentage (0-100)"
          type="number"
          valueAs="float"
          className="my-3"
          inline
          big={false}
          path="rejection"
        />
      </SearchFilterCallout>
      <SearchFilterCallout title={`Rate ${currencySymbol}`}>
        <StringInput
          label="Benchmark Rate"
          type="number"
          valueAs="float"
          inline
          className="my-3"
          big={false}
          path="recommendedBenchmarkRate"
        />
      </SearchFilterCallout>
      <SearchFilterCallout title="Pricing Done On">
        <StaticSelector
          label="Pricing done on"
          items={PRICING_DONE_ON}
          className="my-3"
          inline
          big={false}
          path="pricingDoneOn"
        />
      </SearchFilterCallout>
    </SearchFilter>
  )
}

export default BenchmarkFilter
